import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'form', 'email_input', 'phone_input', 'error' ]

  submitForm(event) {
    this.clearErrorFields()
    this.errorTargets[0].textContent = 'Please enter a valid email'
    let emailValue = this.email_inputTarget.value.trim()
    let phoneValue = this.phone_inputTarget.value.trim()
    let isEmailValid = this.validateForm(emailValue)
    let isPhoneValid = this.validatePhoneNumber()

    if (phoneValue.length === 0 && emailValue.length > 0){
      this.clearErrorFields()
      if (!isEmailValid){
        event.preventDefault()
        this.errorTargets[0].textContent = 'Please enter a valid email'
      }
    }else if (phoneValue.length > 0 && emailValue.length === 0){
      this.clearErrorFields()
      if (!isPhoneValid){
        event.preventDefault()
        this.errorTargets[1].textContent = 'Please enter a valid phone number'
      }
    }else if (phoneValue.length === 0 && emailValue.length === 0){
      event.preventDefault()
      this.errorTargets[0].textContent = 'Please enter a valid email'
      this.errorTargets[1].textContent = 'Please enter a valid phone number'
    }else if (phoneValue.length > 0 && emailValue.length > 0){
      this.clearErrorFields()
    }
  }

  validateForm(email) {
    let isValid = true;

    if(email.length === 0 || (isNaN(email) && !email.match( /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/gi))) {
      isValid = false;
    }

    return isValid;
  }

  isPhoneNumber(str) {
    return this.digitsCount(str) > (str.length / 2);
  }

  digitsCount(str) {
    return str.replace(/[^0-9]/g, '').length;
  }

  validatePhoneNumber(){
    return itis.contact_phone.isValidNumber()
  }

  clearErrorFields(){
    this.errorTargets[0].textContent = ''
    this.errorTargets[1].textContent = ''
  }
}
